import React from 'react';
import { Button, Tooltip } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

const OpenNewWindowButton = ({ url }) => {
  if (!url) return null;
  
  return (
    <Tooltip title="Open in new window">
      <Button 
        size="small"
        variant="outlined"
        startIcon={<OpenInNewIcon />}
        onClick={() => window.open(url, '_blank')}
      >
        Open document in new tab
      </Button>
    </Tooltip>
  );
};

export default OpenNewWindowButton;
